module.exports = __webpack_public_path__ + "img/oil-gathering.06d9132f.png";